export const state = () => ({
  areaForms: [
    {
      name: '進抽站',
      url: 'intakeStation'
    },
    {
      name: '前處理',
      url: 'preprocess'
    },
    {
      name: '初沉池',
      url: 'primaryPond'
    },
    {
      name: '生物池',
      url: 'biologicalPool'
    },
    {
      name: '二沉池',
      url: 'secondaryPond'
    },
    {
      name: '消毒流放池',
      url: 'disinfectionPool'
    },
    {
      name: '污泥機房',
      url: 'sludgeRoom'
    },
    {
      name: '鼓風機房',
      url: 'blowerRoom'
    }
  ],
  dailyForms: [
    {
      name: '缺氧池',
      url: 'anoxicPool'
    },
    {
      name: '初沉池',
      url: 'bioProcessUnit'
    },
    {
      name: '前處理',
      url: 'preprocessUnit'
    },
    {
      name: '消毒池',
      url: 'dailyDisinfectionPool'
    },
    {
      name: '污泥機房',
      url: 'dailySludgeRoom'
    },
    {
      name: '進流抽水站',
      url: 'waterPumpingStation'
    }
  ],
  weatherForms: [
    {
      text: '陰天',
      value: '陰'
    },
    {
      text: '晴天',
      value: '晴'
    },
    {
      text: '雨天',
      value: '雨'
    }
  ]
})

export const getters = {
  areaFormsGetter: state => state.areaForms || [],
  dailyFormsGetter: state => state.dailyForms || [],
  weatherFormsGetter: state => state.weatherForms || []
}

export const mutations = {
}

export const actions = {
}
